module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-overlay"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6625cbab","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/LoadingOverlay/index.vue
// module id = 749
// module chunks = 3